module.exports = __webpack_public_path__ + "static/emanagement7-0bda5727698f7eb6e2e45fe98a3b2317.png";